import { render, staticRenderFns } from "./SettlementCalculation.vue?vue&type=template&id=0a3bd4c4&"
import script from "./SettlementCalculation.vue?vue&type=script&lang=js&"
export * from "./SettlementCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports